import cn from "classnames";
import type React from "react";
import styles from "./Stepper.module.scss";

type Steps = {
	index: number;
	current: boolean;
	completed: boolean;
};

type Props = {
	steps: Steps[];
};

export const Stepper: React.FC<Props> = ({ steps }) => {
	return (
		<div className={styles.container}>
			{steps.map((step, index) => {
				return (
					<div
						key={step.index}
						className={cn(styles.step, {
							[styles.current]: step.current,
							[styles.completed]: step.completed,
						})}
					/>
				);
			})}
		</div>
	);
};
